export { FlagIconLabel } from './FlagIconLabel';
